import { createSelector } from 'reselect';
import { getProjectListData } from 'src/modules/project-list/selectors/getProjectListData';

export const getProjectListQuery = createSelector([
  getProjectListData,
], (data) => data.query);
